import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location } from "@angular/common";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/app.reducer";
import { ActivatedRoute } from "@angular/router";
import { NotificationModalComponent } from "../../../common-components/notification-modal/notification-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { NotificationsService } from "angular2-notifications";
import { AddMemberGroupComponent } from "../add-member-group/add-member-group.component";
import {
    GetPrivateMemberGroupDetails,
    AddPrivateMemberToGroup,
    UpdatePrivateMemberGroup,
    RemoveUserFromPrivateMemberGroup
} from '../store/private-member.action';
import { FormBuilder, FormGroup } from "@angular/forms";
import { tap, takeUntil } from "rxjs/operators";


@Component({
    selector: 'app-private-member-group-detail',
    templateUrl: './private-member-group-detail.component.html',
    styleUrls: ['./private-member-group-detail.component.scss'],
    changeDetection : ChangeDetectionStrategy.OnPush
})
export class PrivateMemberGroupDetailComponent implements OnInit {

    displayedColumns = ["member-name", "remove-member"];
    groupId;
    groupDetails$;
    form: FormGroup;
    groupDetails: any;
    updateButtonClicked: boolean = false;

    constructor(
        private _store: Store<AppState>,
        private location: Location,
        private activateRoute: ActivatedRoute,
        private dialog: MatDialog,
        private notificationService: NotificationsService,
        private fb: FormBuilder
    ) {
        this.activateRoute.params.subscribe(params => {
            this.groupId = params.id;
            this._store.dispatch(new GetPrivateMemberGroupDetails(this.groupId));
        });
    }

    ngOnInit() {
        this.form = this.fb.group({
            'group-name': [''],
            'description': ['']
        })

        this.groupDetails$ = this._store.select(state => state.privateMember.groupDetails).pipe(tap((data) => {
            this.groupDetails = data;

            if (data && Object.keys(data).length) {
                this.form.setValue({
                    'group-name': data.name || '',
                    'description': data.description || ''
                })
            }
        }));
    }

    tabChange(event) {
        if (event.index === 1) {
            this.updateButtonClicked = false
        }
    }

    updateClicked() {
        console.log(this.form.value, "formValu")
        this.updateButtonClicked = true;
        this._store.dispatch(new UpdatePrivateMemberGroup(this.groupDetails._id, this.form.value))

    }

    cancel() {
        this.location.back();
    }

    goToEditGroup(datum) {
        const dialogRef = this.dialog.open(AddMemberGroupComponent, {
            width: "60%",
            data: datum,
            panelClass: 'cmp-modal',
        });
        dialogRef.afterClosed().subscribe(result => {
            //in second tab write what needs to be done after closed;
            if (result && result.type === 'getUserDetails') {
                this.notificationService.success(result.resp[0].message);
                this._store.dispatch(new GetPrivateMemberGroupDetails(this.groupId));
            }
        });
    }

    // RemoveConfirmation() {
    //     const dialogRef = this.dialog.open(NotificationModalComponent, {
    //         width: "500px",
    //         data: {
    //             text: "Are you sure want to delete this group ? "
    //         }
    //     });
    //     dialogRef.afterClosed().subscribe(result => {
    //         // if (result) {
    //         //   this._store.dispatch(new DeleteGroup(this.groupId));
    //         // }
    //     });
    // }

    removeUser(user) {
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: "500px",
            panelClass:'cmp-modal',
            data: {
                text: `Are you sure you want to remove ${
                    user.firstName
                    } ${user.middleName || ""} ${user.lastName} from this private member list?`
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                let payload = {
                    members: [user._id]
                }
                this._store.dispatch(new RemoveUserFromPrivateMemberGroup(this.groupId, user._id));
            }
        });
    }

    // goToEditGroup(datum) {
    //     const dialogRef = this.dialog.open(AddMemberGroupComponent, {
    //         width: "60%",
    //         data: datum
    //     });
    //     dialogRef.afterClosed().subscribe(result => {
    //         if (result) {
    //             this.notificationService.success(result);
    //         }
    //     });
    // }

}
